import MiniCalendar from "components/calendar/MiniCalendar";
import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import PLWisePieChart from "./components/UserLevelAnalyticsPieChart";
import {IoMdCheckmark, IoMdHome} from "react-icons/io";
import {IoDocuments, IoShieldCheckmark} from "react-icons/io5";
import {
    MdAccessibilityNew,
    MdBarChart, MdCheck,
    MdDashboard, MdFiberNew, MdLtePlusMobiledata, MdNewLabel, MdNewReleases,
    MdPeople,
    MdPeopleAlt, MdPlusOne,
    MdSupervisedUserCircle,
    MdTimer,
    MdVerifiedUser
} from "react-icons/md";
import React, {useEffect, useState} from "react";
import {AES, enc} from 'crypto-js';
import axios from "axios";
import moment from "moment";


import {columnsDataCheck, columnsDataComplex} from "./variables/columnsData";

import Widget from "components/widget/Widget";
import CheckTable from "views/admin/users/components/CheckTable";
import ComplexTable from "views/admin/default/components/ComplexTable";
import TaskCard from "views/admin/default/components/TaskCard";
import tableDataCheck from "./variables/tableDataCheck.json";
import tableDataComplex from "./variables/tableDataComplex.json";

import {useUserAuth} from "../../../context/UserAuthContext";
import {useNavigate} from "react-router-dom";
import useAsyncEffect from "use-async-effect";
import ActivatedUsersTrendGraph from "./components/ActivatedUsersTrendGraph";
import DeletedUsersTrendGraph from "./components/DeletedUsersTrendGraph";
import UserLevelAnalyticsPieChart from "./components/UserLevelAnalyticsPieChart";
import UserLevelVoiceAnalyticsPieChart from "./components/UserLevelVoiceAnalyticsPieChart";
import FeedbacksBarGraph from "./components/FeedbacksBarGraph";
import SharedUserAnalyticsBarGraph from "./components/SharedUserAnalyticsBarGraph";
import SharedUserStatsTextSection from "./components/SharedUserStatsTextSection";
import ExecutedSchedulesMonthlyTrend from "../devices/components/ExecutedSchedulesMonthlyTrend";
import AppRatingMonthlyTrend from "./components/AppRatingMonthlyTrend";
import UserFeedbackTrend from "./components/UserFeedbackTrend";
import LocationDataStateCityWise from "./components/LocationDataStateCityWise";
import DeviceInteractions from "./components/DeviceInteractions";
import IndiaChloroplethMap from "./components/IndiaChloroplethMap";
import UserDetailsStatsTable from "./components/UserDetailsStatsTable";
import LocationDataStatePieChart from "./components/LocationDataStatePieChart";
import Alerts from "../error";

const Dashboard = () => {

    var sv = "";

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    const [summaryValues, setSummaryValues] = useState([]);
    const [summaryNumberValues, setSummaryNumberValues] = useState([]);

    var stats = [];
    var statsNumber = [];

    const monthsmap = new Map([["01", "Jan"], ["02", "Feb"], ["03", "Mar"], ["04", "Apr"], ["05", "May"], ["06", "Jun"], ["07", "Jul"], ["08", "Aug"], ["09", "Sep"], ["10", "Oct"], ["11", "Nov"], ["12", "Dec"],]);
    const [message, setErrorMessage] = useState("");

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    function formatDateForApi(date) {
        var d = date.split("-");
        var y = d[0]
        var m = d[1]
        var da = d[2]
        date = da + "-" + m + "-" + y
        ////console.log(date)
        return date
    }

    const [LowerDate, setLowerDate] = useState(addMonths(new Date(new Date().toISOString().slice(0, 10)), -11));
    const [UpperDate, setUpperDate] = useState(new Date().toISOString().slice(0, 10));

    function handleStartDateChange(lowerDate) {
        setLowerDate(lowerDate)
        sessionStorage.setItem("startDate", lowerDate)
    }

    function handleEndDateChange(upperDate) {
        setUpperDate(upperDate)
        sessionStorage.setItem("endDate", upperDate)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleIncreaseDate = (currentDate) => {
        const newDate = moment(currentDate, 'DD-MM-YYYY').add(1, 'days');
        currentDate = newDate.format('DD-MM-YYYY')
        //console.log("CURRENT DATE: ", currentDate)
        return currentDate
    };

    useAsyncEffect(async () => {

        async function getOverallSummary() {
            if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "3") || (accesscontrollevel.toString() === "5")) {
                var url = CROMPTON_ANALYTICS_URL + "v1/user/statistics"
                let analyticsSummary = JSON.parse(sessionStorage.getItem("AnalyticsSummary"))
                //console.log(analyticsSummary)
                for (var i in analyticsSummary) {
                    stats.push(i);
                    statsNumber.push(analyticsSummary[i])
                }
                setSummaryValues(stats);
                setSummaryNumberValues(statsNumber);

                /*axios({
                    method: "GET", url: url, headers: {
                        Authorization: decryptedValue,
                    }

                }).then((res) => {
                    //console.log(res.data)
                    for (var i in res.data) {
                        stats.push(i);
                        statsNumber.push(res.data[i])
                    }
                    setSummaryValues(stats);
                    setSummaryNumberValues(statsNumber);
                    //getMonthlyRegisteredUsersTrend()


                }).catch((error) => {
                    if (error.response.data.status === "401" || error.response.data.status === "403") {
                        handleLogOut();
                    }
                })*/

            } else {
                //console.log("Inside stats non admin")
                setErrorMessage("You do not have permission to view this. Please contact admin.")
            }
        }

        await getOverallSummary()

    }, [sv]);


    return (
        <div>
            {/* Card widget */}

            {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "5" ?

                <div
                    className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
                    <Widget
                        icon={<MdPeople className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={"Total Registered Users"}
                        subtitle={summaryNumberValues[0] + "*"}
                        percentage={summaryNumberValues[6]}
                    />
                    <Widget
                        icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                        title={"Average Active Users"}
                        subtitle={summaryNumberValues[2]}
                        percentage={summaryNumberValues[8]}
                    />
                    <Widget
                        icon={<MdAccessibilityNew className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Registrations"}
                        subtitle={summaryNumberValues[1]}
                        percentage={summaryNumberValues[7]}
                    />
                    {/*<Widget
                    icon={<MdDashboard className="h-6 w-6"/>}
                    title={"Total Activated Devices"}
                    subtitle={summaryNumberValues[3] + "*"}
                />
                <Widget
                    icon={<MdBarChart className="h-7 w-7"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                    subtitle={summaryNumberValues[5]}
                />
                <Widget
                    icon={<IoMdHome className="h-6 w-6"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                    subtitle={summaryNumberValues[4]}
                />*/}
                </div>
                :
                <div
                    className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-3">
                    <Widget
                        icon={<MdPeople className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={"Total Registered Users"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    <Widget
                        icon={<IoShieldCheckmark className="h-7 w-7 text-[#004c86] dark:text-white"/>}
                        title={"Average Active Users"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    <Widget
                        icon={<MdAccessibilityNew className="h-6 w-6 text-[#004c86] dark:text-white"/>}
                        title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Registrations"}
                        subtitle={"--"}
                        percentage={"--"}
                    />
                    {/*<Widget
                    icon={<MdDashboard className="h-6 w-6"/>}
                    title={"Total Activated Devices"}
                    subtitle={summaryNumberValues[3] + "*"}
                />
                <Widget
                    icon={<MdBarChart className="h-7 w-7"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Active Devices"}
                    subtitle={summaryNumberValues[5]}
                />
                <Widget
                    icon={<IoMdHome className="h-6 w-6"/>}
                    title={monthsmap.get(new Date().toISOString().slice(5, 7)) + " Activated"}
                    subtitle={summaryNumberValues[4]}
                />*/}
                </div>
            }
            {/* Charts */}

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                    <ActivatedUsersTrendGraph/> : <Alerts/>}
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                    <DeletedUsersTrendGraph/> : <Alerts/>}
            </div>

            {/* Tables & Charts */}

            <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                    <LocationDataStateCityWise/> : <Alerts/>}
                {accesscontrollevel.toString() === "1" || (accesscontrollevel.toString() === "5")?
                    <DeviceInteractions/> : <Alerts/>}

                <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                        <UserLevelAnalyticsPieChart/> : <Alerts/>}
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                        <UserLevelVoiceAnalyticsPieChart/> : <Alerts/>}
                </div>

                <div className="grid grid-cols-1 gap-5 rounded-[20px] md:grid-cols-2">
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                        <SharedUserStatsTextSection/> : <Alerts/>}
                    {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                        <SharedUserAnalyticsBarGraph/> : <Alerts/>}
                </div>

                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                    <AppRatingMonthlyTrend/> : <Alerts/>}
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "4" || (accesscontrollevel.toString() === "5")?
                    <UserFeedbackTrend/> : <Alerts/>}

            </div>

            {/*<div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-1">
                <UserDetailsStatsTable/>
            </div>*/}

            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                {accesscontrollevel.toString() === "1" || accesscontrollevel.toString() === "3" || (accesscontrollevel.toString() === "5")?
                    <LocationDataStatePieChart/> : <Alerts/>}
            </div>

        </div>
    );
};

export default Dashboard;
